import React from 'react';
import { ATTACHABLES_LABELS } from '../constants/AttachmentConstants';

export default class AttachmentDataMiniTable extends React.Component {
  constructor(props) {
    super(props);
  }
  // =====================
  // Render Component
  // =====================
  render() {
    return (
      <div className="table-responsive mb-4" style={{maxHeight: "50vh", maxWidth: "100vw", overflow: "auto"}}>
        <table className="table table-bordered table-hover align-middle mb-0">
          <thead className="table-success">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Doctor</th>
              <th scope="col">Hospital</th>
              <th scope="col">Polyclinic</th>
              <th scope="col">Guarantor</th>
              <th scope="col">Attachment Number</th>
              <th scope="col">Assessment Type</th>
              <th scope="col">Attachable Type</th>
              <th scope="col">Attachable Name</th>
            </tr>
          </thead>
          <tbody>
            {this.props.attachments?.map((attachment) => (
              <tr key={attachment.id}>
                <td>{attachment.profile_full_name}</td>
                <td>{attachment.doctor_full_name}</td>
                <td>{attachment.hospital_name}</td>
                <td>{attachment.polyclinic}</td>
                <td>{attachment.guarantor}</td>
                <td>{attachment.attachment_number}</td>
                <td>{attachment.assessment_type}</td>
                <td>{ATTACHABLES_LABELS[attachment.attachable_type]}</td>
                <td>{attachment.attachable_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
